const isValid = (value) => {
  return value !== undefined && value !== null;
};

const isNumber = (value) => {
  return typeof value === "number";
};

const isObject = (value) => {
  return typeof value === "object";
};

const biggerThan = (number) => (value) => {
  return value > number;
};

const smallerThan = (number) => (value) => {
  return value < number;
};

const isTypeOf = (type) => (value) => {
  return typeof value === type;
};

const randomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const isString = isTypeOf("string");

const isFunction = isTypeOf("function");

const isArray = (value) => Array.isArray(value);

const toArray = (item) => {
  if (item === undefined) return [];
  return isArray(item) ? item : [item];
};

const biggerThanZero = biggerThan(0);

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Deep clone an object
const clone = (obj) => {
  if (obj === null || typeof obj !== "object" || "isActiveClone" in obj)
    return obj;

  let temp;

  if (obj instanceof Date) temp = new obj.constructor();
  //or new Date(obj);
  else temp = obj.constructor();

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj["isActiveClone"] = null;

      if (key === "_id") {
        temp[key] = uuidv4();
      } else {
        temp[key] = clone(obj[key]);
        delete obj["isActiveClone"];
      }
    }
  }
  return temp;
};

const objToArray = (obj) => {
  return Object.values(obj);
};

export {
  isValid,
  isNumber,
  isObject,
  isTypeOf,
  randomNumber,
  isString,
  isFunction,
  isArray,
  toArray,
  uuidv4,
  clone,
  biggerThanZero,
  smallerThan,
  objToArray
};
